import axios from 'axios';
import { alertDOnSuccess, alertOnSuccess2, alertSOnSuccess } from './alertAction';

export const SIGN_UP = 'SIGN_UP';
const signUpSuccess = (data) => ({
    type: SIGN_UP,
    signUpAction:data
})
export const signUpUser = (fullname, email, phonenumber, dateofbirth, password) => {
    return async (dispatch) => {
        try {
            const response = await axios.post('/signup',{fullname, email, phonenumber, dateofbirth, password});
            dispatch(signUpSuccess(response.data));
            dispatch(alertSOnSuccess())
        } catch (error) {
            dispatch(alertDOnSuccess())
            // if(error.response && error.response.data){
            //     console.error("Lỗi khi đăng ký",error.response);
            // }
        }
    }
}
export const confirm = (token,navigates) => {
    return async (dispatch) => {
        try {
            const response = await axios.post(`/signup/confirm?token=${token}`,{});
            if (response.status === 401) {
                alert('Token đã hết hạn. Vui lòng yêu cầu một liên kết xác thực mới.');
            }
            navigates('/signup',{ state: { successMessage: 'Đăng ký thành công!' } });
            dispatch(alertOnSuccess2())
        } catch (error) {
                console.error("Lỗi khi đăng ký",error.response);

        }
    }
}